import React from "react";
import { BsInfoCircle } from "react-icons/bs";
import { FiArrowRight } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import { JOB_POSTING_ACCESS_MESSAGES } from "../../../Helper/subscriptionHelper";

const NoSubscriptionAlert = ({ salesHistory }) => {
  const navigate = useNavigate();

  if (!salesHistory) {
    return <BeatLoader color="#4893B3" size={12} />;
  }

  if (salesHistory?.length > 0) {
    return null;
  }

  return (
    <div className="employer-no-sub-banner">
      <p className="employer-no-sub-banner-text">
        <BsInfoCircle style={{ marginRight: "0.5rem", verticalAlign: "middle" }} />
        {JOB_POSTING_ACCESS_MESSAGES.no_subscription}
      </p>
      <button
        onClick={() => navigate("/employer/package")}
        className="employer-btn employer-btn-primary employer-btn-sm"
      >
        View Packages <FiArrowRight />
      </button>
    </div>
  );
};

export default NoSubscriptionAlert;
